import { useTranslation } from 'react-i18next'

import { roleLabel } from '@/lib/navigation'
import type { Role } from '@/types/domain'

/** Renders a role's name: translated for the five shipped roles, and the
 *  founder's own words for one they created (migration 0021). */
export function RoleName({ role, name }: { role: Role; name?: string }) {
  const { t } = useTranslation()
  const label = roleLabel(role, name)
  return <>{label.translated ? t(label.key) : label.text}</>
}
